module.exports = __webpack_public_path__ + "img/loading_ball.1d7626e6.gif";